<template>
  <div class="sidemenu-body">
    <b-tabs @activate-tab="onActiveTab">
      <b-tab title="MD">
        <VuePerfectScrollbar>
          <ul class="sidemenu-nav metisMenu h-100" id="sidemenu-nav" data-simplebar>
            <template v-for="(menu, index) in mdMenu">
              <li class="nav-item" v-if="menu.children && menu.children.length > 0" :key="index">
                <a
                  class="nav-link collapsed-nav-link"
                  v-b-toggle="'accordion-' + menu.id"
                  @click="changeMenu(menu)"
                >
                  <i class="bx bx-folder-open"></i>
                  <span class="menu-title">{{ menu.label }}</span>
                </a>
                <b-collapse
                  :id="'accordion-' + menu.id"
                  accordion="my-accordion"
                  role="tabpanel"
                  class="sidemenu-nav-second-level"
                >
                  <div
                    v-for="(subItem, subIndex) in menu.children"
                    :key="subIndex"
                  >
                    <li class="nav-item" @click="changeRoute(subItem)">
                      <router-link v-if="checkIsMyPortal(subItem)" :to="subItem.originMenuPath" class="nav-link">
                        <span class="menu-title">{{ subItem.label }}</span>
                      </router-link>
                      <a v-else :href="subItem.url" class="nav-link" :target="subItem.target || '_self'">
                        <span class="menu-title">{{ subItem.label }}</span>
                      </a>
                    </li>
                  </div>
                </b-collapse>
              </li>

              <router-link
                v-else
                custom
                :key="menu.id"
                :to="menu.originMenuPath || '/'"
                v-slot="{ href, navigate, isActive, isExactActive }"
              >
                <li
                  class="nav-item"
                  :class="[
                    isActive && 'router-link-active mm-active',
                    isExactActive && 'router-link-exact-active'
                  ]"
                  @click="changeMenu(menu)"
                >
                  <a :href="href" @click="navigate" class="nav-link" :target="menu.target || '_self'">
                    <i class="bx bx-link"></i>
                    <span class="menu-title">{{ menu.label }}</span>
                  </a>
                </li>
              </router-link>
            </template>
          </ul>
        </VuePerfectScrollbar>
      </b-tab>

      <b-tab title="Gốc" active>
        <VuePerfectScrollbar>
          <ul class="sidemenu-nav metisMenu h-100" id="sidemenu-nav" data-simplebar>
            <template v-for="(menu, index) in originalMenu">
              <li class="nav-item" v-if="menu.children && menu.children.length > 0" :key="index">
                <a
                  class="nav-link collapsed-nav-link"
                  v-b-toggle="'accordion-' + menu.id"
                  @click="changeMenu(menu)"
                >
                  <i class="bx bx-folder-open"></i>
                  <span class="menu-title">{{ menu.label }}</span>
                </a>
                <b-collapse
                  :id="'accordion-' + menu.id"
                  accordion="my-accordion"
                  role="tabpanel"
                  class="sidemenu-nav-second-level"
                >
                  <div
                    v-for="(subItem, subIndex) in menu.children"
                    :key="subIndex"
                  >
                    <div v-if="subItem.children && subItem.children.length > 0">
                      <a
                        class="nav-link collapsed-nav-link nav-link-sub"
                        v-b-toggle="'accordion-' + subItem.id"
                        style="padding-left: 0"
                        @click="changeMenu(subItem)"
                      >
                        <span class="menu-title">{{ subItem.label }}</span>
                      </a>
                      <b-collapse
                        :id="'accordion-' + subItem.id"
                        :accordion="`sub-accordion-${subItem.id}`"
                        role="tabpanel"
                        class="sidemenu-nav-second-level"
                      >
                        <li v-for="subMenuLv2 in subItem.children" class="nav-item" @click="changeRoute(subItem)" :key="subMenuLv2.id">
                          <router-link v-if="checkIsMyPortal(menu)" :to="subMenuLv2.originMenuPath" class="nav-link">
                            <span class="menu-title">{{ subMenuLv2.label }}</span>
                          </router-link>
                          <a v-else :href="subMenuLv2.url" class="nav-link" :target="subMenuLv2.target || '_self'">
                            <span class="menu-title">{{ subMenuLv2.label }}</span>
                          </a>
                        </li>
                      </b-collapse>
                    </div>
                    <template v-else>
                      <li class="nav-item" @click="changeRoute(subItem)">
                        <router-link v-if="checkIsMyPortal(menu)" :to="subItem.originMenuPath" class="nav-link">
                          <span class="menu-title">{{ subItem.label }}</span>
                        </router-link>
                        <a v-else :href="subItem.url" class="nav-link" :target="subItem.target || '_self'">
                          <span class="menu-title">{{ subItem.label }}</span>
                        </a>
                      </li>
                    </template>

                  </div>
                </b-collapse>
              </li>

              <template v-else>
                <template v-if="checkIsMyPortal(menu)">
                  <router-link
                    custom
                    :key="menu.id"
                    :to="menu.originMenuPath || '/'"
                    v-slot="{ href, navigate, isActive, isExactActive }"
                  >
                    <li
                      class="nav-item"
                      :class="[
                        isActive && 'router-link-active mm-active',
                        isExactActive && 'router-link-exact-active'
                      ]"
                      @click="changeMenu(menu)"
                    >
                      <a :href="href" @click="navigate" class="nav-link" :target="menu.target || '_self'">
                        <i class="bx bx-link"></i>
                        <span class="menu-title">{{ menu.label }}</span>
                      </a>
                    </li>
                  </router-link>
                </template>
                <template v-else>
                  <li
                    class="nav-item"
                    :key="menu.id"
                    @click="changeMenu(menu)"
                  >
                    <a :href="menu.url" class="nav-link" :target="menu.target || '_self'" >
                      <i class="bx bx-link"></i>
                      <span class="menu-title">{{ menu.label }}</span>
                    </a>
                  </li>
                </template>
              </template>
            </template>
          </ul>
        </VuePerfectScrollbar>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { menu } from '@/config/menu_v2.js'
import { mapGetters } from 'vuex'
import { MenuService } from '@/services/menu.service'

const myPortal = 'mynextpay'

export default {
  components: {
    VuePerfectScrollbar
  },

  props: {
    isOpen: Boolean,
    isOpenMobile: Boolean
  },

  data () {
    return {
      sidebarActive: false,
      collapsed: true,
      windowWidth: 0,
      menu: menu,
      mdMenu: [],
      originalMenu: [],
      activeTab: true,
      isAutoExpand: false
    }
  },

  // filters: {
  //   isMyPortal: function (menu) {
  //     return menu.portalName === myPortal
  //   }
  // },

  computed: {
    ...mapGetters({
      getRouterSavingSearch: 'search/getRouter',
      dataPermission: 'role/dataPermission'
    })
  },

  mounted: function () {
    this.loadData()
  },

  methods: {
    checkIsMyPortal: function (menu) {
      return menu.portalName === myPortal
    },

    async loadData () {
      try {
        const res = await MenuService.getMenu()
        this.mdMenu = res.data.mdMenu.children

        const mnpMenu = res.data.originalMenu.children.filter(menu => {
          return menu.portalName === myPortal;
        });

        this.originalMenu = mnpMenu.length > 0 ? [
          ...mnpMenu,
          ...res.data.originalMenu.children.filter(menu => menu.portalName !== myPortal),
        ] : res.data.originalMenu.children;

        // this.$nextTick(() => {})
        setTimeout(() => {
          this.onActiveTab(1)
        }, 500);
      } catch (e) {
        console.error(e)
      }
    },

    checkPermission (per) {
      return true
    },
    checkChild (child) {
      return true
    },
    changeRoute (item) {
      if (item !== '/attendance') {
        this.$store.commit('search/CLEAR_DATA')
      }
      if (this.getRouterSavingSearch !== null && item !== this.getRouterSavingSearch) {
        this.$store.commit('search/CLEAR_DATA_OTHER')
      }
    },
    changeMenu (item) {
      if (item.accId !== 2) {
        this.$store.commit('search/CLEAR_DATA')
      }
      if (this.getRouterSavingSearch !== null && item.href && item.href !== this.getRouterSavingSearch) {
        this.$store.commit('search/CLEAR_DATA_OTHER')
      }
    },
    onActiveTab (id) {
      if (id === 1 && !this.isAutoExpand) {
        this.$nextTick(() => {
          this.isAutoExpand = true
          document.querySelector(`[aria-controls='accordion-${this.originalMenu[0].id}']`).click()
        });
      }
    }
  }
}
</script>

<style scoped>
.router-link-exact-active {
  color: #0B62AB !important;
}
.nav-link-sub::before {
  background: none !important;
}
</style>

<style>
.sidemenu-area.toggle-sidemenu-area ul.nav-tabs {
  display: none;
}

.sidemenu-area:hover.toggle-sidemenu-area ul.nav-tabs {
  display: flex;
}

.sidemenu-area.toggle-sidemenu-area ul.sidemenu-nav li a.nav-link {
  padding-top: 24px !important;
}

.sidemenu-area:hover.toggle-sidemenu-area ul.sidemenu-nav li a.nav-link {
  padding-top: 10px !important;
}
</style>
